module.exports = __webpack_public_path__ + "static/media/SiRating_logo_dark_text_2.57b7c10a.svg";